// @flow
import React from "react";
import Header from "components/Header";
import { type FormResultDTO, type DocFormResultDTO } from "data/types";
import loc from "i18next";

type Props = {
    /** current Form being edited */
    form?: FormResultDTO | DocFormResultDTO,
    /** callback when user clicks Cancel */
    onCancel: () => void,
    /** default form title to use when formTitle/name not supplied
     * @default {string} null so use i18next localization upload:edit_form.title
     */
    title?: string,
    /** optional icon to display
     * @default {string} edit
     */
    icon?: string,
    /** optional center component */
    centerComponent?: React.ElementType,
};

/**
 * renders the FormEdit's panel header
 *
 * @param {Props} { form, onCancel }
 */
const FormEditHeader = ({
    icon,
    form,
    onCancel,
    title,
    centerComponent,
}: Props) => (
    <Header
        icon={icon}
        title={
            form.formTitle ||
            form.name ||
            title ||
            loc.t("upload:edit_form.title")
        }
        centerComponent={centerComponent}
        onCancel={onCancel}
    />
);
FormEditHeader.displayName = "FormEditHeader";
FormEditHeader.defaultProps = {
    icon: "edit",
};
export default FormEditHeader;
